import { Controller } from "@hotwired/stimulus";
import { misc } from "./customization/category";
import Customization from "./customization";
import { buildForm, makeRequest } from "./customization/lib";
import { initToast } from "./customization/lib";

// Connects to data-controller="site-builder-support-form"
export default class extends Controller {
  static targets = ["email", "phone", "submitButton"];

  static outlets = ["site-builder--brand"];

  connect() {
    initToast(this);
  }

  assignFormFields() {
    this.constructor.targets.forEach((target) => {
      const tarInstance = this[`${target}Target`];
      const match = tarInstance.name?.match(/site_builder\[(.*)]/);
      if (match) {
        const key = match[1];
        tarInstance.value = misc.values[key] || "";
      }
    });
  }

  updateText(event) {
    const target = event.currentTarget;
    Customization.localUpdate({
      [target.name]: target.value.trim(),
    });
    this.siteBuilderBrandOutlet.assignFormFields();
  }

  async submitSupport(e) {
    e.preventDefault();
    const formData = buildForm("Get Full Access Popup");
    makeRequest(formData);
    document.querySelector(".modal").close();
    this.#showSuccessMessage();
  }

  #showSuccessMessage() {
    this.toast.info.show(
      "Request submitted successfully!",
      "Our product expert will be in touch soon. Or book a demo instantly here."
    );
  }
}
